import { type ReactNode } from 'react'
import type { GraphNode } from '@/api/graph'

/**
 * The familiar answers in the graph's own notation: entities come back as [[Exact Name]].
 * We resolve each against the live graph so the answer is a path you can walk, not prose about one.
 *
 * Lives outside Familiar.tsx because Fast Refresh requires component modules to export only
 * components — and because this is the piece worth testing on its own.
 */
const CITATION = /\[\[([^\]]+)\]\]/g

export function renderAnswer(
  text: string,
  byName: Map<string, GraphNode>,
  // The clicked element is handed back so the caller can anchor a popover (the EntityPeek) to it.
  onPick: (n: GraphNode, anchor: HTMLElement) => void,
): ReactNode[] {
  const parts: ReactNode[] = []
  let cursor = 0
  let match: RegExpExecArray | null

  CITATION.lastIndex = 0
  while ((match = CITATION.exec(text)) !== null) {
    if (match.index > cursor) parts.push(text.slice(cursor, match.index))
    const label = match[1]
    const node = byName.get(label.toLowerCase())
    if (node) {
      parts.push(
        <button
          key={`${match.index}-${label}`}
          type="button"
          className="dw-cite"
          onClick={(e) => onPick(node, e.currentTarget)}
          title={`Quick look at ${node.name}`}
        >
          {label}
        </button>,
      )
    } else {
      // The familiar named something the graph doesn't hold. Show the name, not the brackets.
      parts.push(label)
    }
    cursor = match.index + match[0].length
  }
  if (cursor < text.length) parts.push(text.slice(cursor))
  return parts
}
